import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import * as moment from 'moment';
import { ActionService } from 'src/app/services/actions/action.service';
import { ConfigsService } from 'src/app/services/configs/configs.service';
import { TenantUIService } from '../../../tenant-ui.service';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-ingestion',
  templateUrl: './ingestion.component.html',
  styleUrls: ['./ingestion.component.scss']
})
export class IngestionComponent implements OnInit {

  @ViewChild('dt', { static: false }) public dt: Table;

  apps: any[];
  working = false;
  states: any[];
  hContracts: any[];
  fileNames: any[];
  selectedApprovals: any[] = [];

  statuses: any[] = [{ "label": "Pending", "value": "Pending" },
  { "label": "Approved", "value": "Approved" },
  { "label": "Rejected", "value": "Rejected" },
  { "label": "Partially Approved", "value": "PartialApproved" }];

  rejectionChips: any[] = [];

  outliers: any[] = [];

  threshold = 2;

  constructor(protected service: TenantUIService,
    private actionService: ActionService,
    public configsService: ConfigsService
  ) {
  }

  async ngOnInit() {
    if (this.service.selectedEntityIndex == this.service.IngestionIndex) {
      this.working = true;

      await this.getStateList();
      await this.getPendingApprovals();

      this.working = false;

      setTimeout(async () => {

        this.working = true;
        this.outliers = await this.getStandardDeviationOutliers();

        if (this.apps) {
          this.updateThreatLevels();
          this.populateStatesDropdown();
          
          this.hContracts = this.distinctByColumn(this.apps, "hContract").sort((a, b) => a.localeCompare(b))   // ensures alphabetical order;
          this.fileNames = this.distinctByColumn(this.apps, "fileName");
        }
        this.working = false;
      }, 250);

      this.working = false;
    }
  }


  async thresholdChanged() {
    this.working = true;
    this.outliers = await this.getStandardDeviationOutliers();

    this.updateThreatLevels();
    this.working = false;
  }

  updateThreatLevels() {
    // console.log("Updating threat levels for threshold..");

    if (!this.outliers) {
      return;
    }

    // if (this.outliers.length == 0) {
    //   return;
    // }

    for (const a of this.apps) {
      let deviations = this.outliers.filter(x => x.state == a.state && x.hContract == a.hContract && x.fileGenerationDate == a.fileGenerationDate);

      // Just save all the counts for the popup dialog.
      a.endDateCountsForContract = deviations.map(x => { return { endDate: x.medicaidStatusEndDate, count: x.occurrenceCount } });
      a.endDateCountsForContract.sort((a, b) => {
        const dateA = a.endDate ? new Date(a.endDate).getTime() : Number.POSITIVE_INFINITY;
        const dateB = b.endDate ? new Date(b.endDate).getTime() : Number.POSITIVE_INFINITY;
        return dateA - dateB; // Ascending order
      });

      if (deviations.length > 0) {
        a.outliers = deviations.filter(x => x.significance == "Significant");

        if (a.outliers && a.outliers.length > 0) {
          a.outliers.sort((a, b) => {
            const dateA = a.medicaidStatusEndDate ? new Date(a.medicaidStatusEndDate).getTime() : Number.POSITIVE_INFINITY;
            const dateB = b.medicaidStatusEndDate ? new Date(b.medicaidStatusEndDate).getTime() : Number.POSITIVE_INFINITY;
            return dateA - dateB; // Ascending order
          });
        }

      } else {
        a.outliers = [];
      }

      if (a.outliers && a.outliers.length > 0) {
        a.ThreatLevel = "High";
      } else {
        a.ThreatLevel = "Low";
      }
    }

    this.apps = [...this.apps];
  }

  requestEdit(app: any) {
    app.editMode = true;
  }

  syncCriteriaToChipsArray(app: any) {
    if (app.RejectionCriteria && app.RejectionCriteria.length > 0) {
      app.RejectionChipsArray = app.RejectionCriteria.map(x => x.Value);
    } else {
      app.RejectionChipsArray = [];
    }
  }

  cancelEdit(app: any) {
    this.syncCriteriaToChipsArray(app);

    app.editMode = false;
  }

  acceptEdit(app: any) {
    this.syncChipArrayToRejectionObjects(app);

    app.editMode = false;
  }

  cleanupApprovalProperties() {
    if (!this.apps || this.apps.length == 0) {
      return;
    }

    for (const a of this.apps) {
      a.editMode = false;
      a.RejectionChipsArray = [];

      if (a.fileGenerationDate) {
        a.generated = this.getLocalDate(a.fileGenerationDate);
      }

      if (a.reviewedStatus == null) {
        a.reviewedStatus = "Pending";
      }
    }
  }

  getLocalDate(date: string) {
    let utcDate = moment.utc(date);

    return utcDate.local().format('YYYY-MM-DD HH:mm');
  }

  distinctByColumn<T, K extends keyof T>(arr: T[], key: K): T[K][] {
    return Array.from(new Set(arr.map(item => item[key])));
  }

  async getStateList() {
    const configPredicate = await this.configsService.firstOrDefault("PREDICATE_LOOKUP", { Key: "state list" });
    this.states = JSON.parse(configPredicate.value).map(x => { return { label: x.name, value: x.id } });
  }

  async getPendingApprovals() {
    let response = await this.actionService.invoke("Ingestion", "get-approvals", {
      tenantId: this.service.selectedTenant.tenantName,
      reviewedStatus: "Pending"
    });

    this.apps = response.approvals;
    this.cleanupApprovalProperties();
  }

  async getStandardDeviationOutliers() {

    // var sampleResponseItem = {
    //         "state": "AL",
    //         "hContract": "H0432",
    //         "fileGenerationDate": "2024-10-05T12:00:00",
    //         "medicaidStatusEndDate": "2024-07-31T12:00:00",
    //         "occurrenceCount": 43,
    //         "meanValue": 5,
    //         "stdDevValue": 7.828029686995815,
    //         "differenceFromMean": 38,
    //         "threshold": 15.65605937399163,
    //         "significance": "Significant"
    // };

    let response = await this.actionService.invoke("Ingestion", "get-outliers", {
      tenantId: this.service.selectedTenant.tenantName,
      multiplier: this.threshold
    });

    return response.outliers;
  }


  addChipToApproval(chipText: string, approval: any) {
    approval.RejectionCriteria.push({
      Field: "MedicaidStatusEndDate",
      Value: chipText,
      Operator: "="
    });

    approval.RejectionChipsArray = approval.RejectionCriteria.map(x => x.Value);
  }

  syncChipArrayToRejectionObjects(app: any) {
    // Sync the array to the object array of medicaid end dates.
    app.RejectionCriteria = [];

    app.RejectionChipsArray.forEach(chip => {
      app.RejectionCriteria.push({
        Field: "MedicaidStatusEndDate",
        Value: chip,
        Operator: "="
      });
    });
  }

  applyRejectionCriteria() {
    this.selectedApprovals.forEach(selected => {
      selected.RejectionCriteria = [];
    });

    this.rejectionChips.forEach(chip => {
      this.selectedApprovals.forEach(selected => {
        this.addChipToApproval(chip, selected);
      });
    });

    this.rejectionChips = [];
    this.selectedApprovals = [];
  }


  async getAllApprovals() {

    let response = await this.actionService.invoke("Ingestion", "get-approvals", {
      tenantId: this.service.selectedTenant.tenantName,
      reviewedStatus: ""
    });

    this.apps = response.approvals;
    this.cleanupApprovalProperties();

  }

  async updateStatusForSelected(newStatus: string) {
    this.working = true;

    await this.actionService.invoke("Ingestion", "approve", {
      tenantId: this.service.selectedTenant.tenantName,
      status: newStatus,
      approvals: this.selectedApprovals
    });

    // Remove this, if not going to delete the entries from the table.
    this.selectedApprovals.forEach(x => {
      let index = this.apps.findIndex(y => y.id == x.id);
      this.apps.splice(index, 1);
    });

    this.populateStatesDropdown();

    this.apps = [...this.apps];

    this.selectedApprovals = [];
    this.working = false;
  }

  populateStatesDropdown() {
    this.states = this.states.filter(x => this.apps.some(y => y.state == x.value));
  }

  async approve() {
    await this.updateStatusForSelected("Approved");
  }

  async reject() {
    await this.updateStatusForSelected("Rejected");
  }


}
